"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferredInsurerDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const insurer_entity_1 = require("./insurer.entity");
const contact_entity_1 = require("./contact.entity");
const opportunity_broking_slip_version_entity_1 = require("./opportunity-broking-slip-version.entity");
let PreferredInsurerDetails = class PreferredInsurerDetails {
};
exports.PreferredInsurerDetails = PreferredInsurerDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "location_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "branch_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetails.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], PreferredInsurerDetails.prototype, "insurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], PreferredInsurerDetails.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails, (brokingSlip) => brokingSlip.preferredInsurerDetails, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], PreferredInsurerDetails.prototype, "brokingSlip", void 0);
exports.PreferredInsurerDetails = PreferredInsurerDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "brokingslip_version_preferred_insurer_detail" })
], PreferredInsurerDetails);
